
const Maintenance = () => {
  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
      <div style={{ background: "#fff", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.08)", padding: "40px 32px", maxWidth: "400px", width: "100%", textAlign: "center" }}>
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" style={{ marginBottom: 24 }}>
          <circle cx="12" cy="12" r="10" fill="#e1e7ef" />
          <path d="M8 13v-2a4 4 0 1 1 8 0v2" stroke="#3b4252" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <rect x="8" y="15" width="8" height="2" rx="1" fill="#3b4252" />
        </svg>
        <h2 style={{ color: "#222", fontWeight: 700, marginBottom: 12 }}>Under Maintenance</h2>
        <p style={{ color: "#555", marginBottom: 24 }}>
          We're currently performing scheduled maintenance.<br />Please check back soon.
        </p>
        {/* <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="maintenance-spinner" style={{ width: 32, height: 32, border: "4px solid #e1e7ef", borderTop: "4px solid #3b4252", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
        </div> */}
        {/* <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style> */}
      </div>
    </div>
  );
};

export default Maintenance;
